import { DocumentSubjectType } from '@/types'
import { Badge } from '../base/badge'

interface BadgeProps {
  subject: DocumentSubjectType
}

export const SubjectBadge = ({ subject }: BadgeProps) => {
  switch (subject) {
    case DocumentSubjectType.Asset: return <Badge color="red">Asset</Badge>
    case DocumentSubjectType.AssetType: return <Badge color="green">Asset type</Badge>
    case DocumentSubjectType.Event: return <Badge color="blue">Event</Badge>
    case DocumentSubjectType.Package: return <Badge color="orange">Package</Badge>
    case DocumentSubjectType.Venue: return <Badge color="purple">Venue</Badge>
  }
}
